// Get variant ID from product - set automatically
var VARIANT_ID = window.GETMYLEASE_VARIANT_ID || 0;

// ── MAKE / MODEL DATA ──
const carModels = {
  acura:      ['Integra','MDX','NSX','RDX','TLX','ZDX'],
  audi:       ['A3','A4','A5','A6','A7','A8','e-tron GT','Q3','Q4 e-tron','Q5','Q7','Q8','Q8 e-tron','RS3','RS5','RS6','RS7','TT'],
  bmw:        ['2 Series','3 Series','4 Series','5 Series','7 Series','8 Series','i4','i5','i7','iX','M2','M3','M4','M5','X1','X2','X3','X4','X5','X5 M','X6','X6 M','X7','Z4'],
  cadillac:   ['CT4','CT5','Escalade','Escalade-V','LYRIQ','OPTIQ','XT4','XT5','XT6'],
  genesis:    ['Electrified G80','Electrified GV70','G70','G80','G90','GV70','GV80','GV90'],
  infiniti:   ['Q50','Q60','QX50','QX55','QX60','QX80'],
  jeep:       ['Cherokee','Compass','Gladiator','Grand Cherokee','Grand Cherokee 4xe','Grand Cherokee L','Grand Wagoneer','Renegade','Wagoneer','Wagoneer L','Wrangler','Wrangler 4xe'],
  lexus:      ['ES','GX','IS','LC','LS','LX','NX','RC','RX','RZ','TX','UX'],
  mazda:      ['CX-30','CX-5','CX-50','CX-70','CX-90','Mazda3','Mazda6','MX-30','MX-5 Miata'],
  mercedes:   ['A-Class','AMG GT','C-Class','CLA','CLE','CLS','E-Class','EQB','EQE','EQS','G-Class','GLA','GLB','GLC','GLE','GLS','S-Class','SL'],
  volkswagen: ['Arteon','Atlas','Atlas Cross Sport','Golf GTI','Golf R','ID. Buzz','ID.4','Jetta','Passat','Taos','Tiguan'],
  volvo:      ['C40 Recharge','EX30','EX90','S60','S90','V60','V90','XC40','XC40 Recharge','XC60','XC90']
};

function updateModels() {
  var make = document.getElementById('field-make');
  var modelSel = document.getElementById('field-model');
  if (!make || !modelSel) return;
  var list = carModels[make.value] || [];
  modelSel.innerHTML = '<option value="">Select model...</option>';
  list.forEach(function(m) {
    var opt = document.createElement('option');
    opt.value = m.toLowerCase().replace(/\s+/g, '-');
    opt.textContent = m;
    modelSel.appendChild(opt);
  });
}

// Budget pill selection
function pickBudget(el) {
  el.parentElement.querySelectorAll('.bpill').forEach(function(p) { p.classList.remove('on'); });
  el.classList.add('on');
  var budgetVal = document.getElementById('budgetVal');
  if (budgetVal) budgetVal.value = el.textContent.trim();
}

// Miles pill selection
function pickMiles(el) {
  el.parentElement.querySelectorAll('.bpill').forEach(function(p) { p.classList.remove('on'); });
  el.classList.add('on');
  var milesVal = document.getElementById('milesVal');
  if (milesVal) milesVal.value = el.textContent.trim();
}

// FAQ accordion
function faq(btn) {
  var row = btn.parentElement;
  var isOpen = row.classList.contains('open');
  document.querySelectorAll('.faq-row').forEach(function(r) { r.classList.remove('open'); });
  if (!isOpen) row.classList.add('open');
}

// Checkout redirect
function goToCheckout() {
  var email = document.getElementById('field-email');
  var name = document.getElementById('field-name');
  if (!email || !email.value.trim()) {
    alert('Please enter your email address to continue.');
    if (email) email.focus();
    return;
  }
  if (!name || !name.value.trim()) {
    alert('Please enter your first name to continue.');
    if (name) name.focus();
    return;
  }
  var make  = document.getElementById('field-make')  ? document.getElementById('field-make').value  : '';
  var model = document.getElementById('field-model') ? document.getElementById('field-model').value : '';
  var zip   = document.getElementById('field-zip')   ? document.getElementById('field-zip').value   : '';
  var term  = document.getElementById('field-term')  ? document.getElementById('field-term').value  : '';
  var down  = document.getElementById('budgetVal')   ? document.getElementById('budgetVal').value   : '';
  var miles = document.getElementById('milesVal')    ? document.getElementById('milesVal').value    : '';

  var btn = document.querySelector('.go-btn');
  if (btn) { btn.textContent = 'Processing...'; btn.disabled = true; }

  var props = {
    'First Name': name.value.trim(),
    'Email': email.value.trim(),
    'Make': make,
    'Model': model.replace(/-/g, ' '),
    'ZIP Code': zip,
    'Lease Term': term,
    'Money Down': down,
    'Miles per Year': miles
  };

  // Clear cart first, then add fresh item, then go to checkout
  fetch('/cart/clear.js', { method: 'POST' })
  .then(function() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: VARIANT_ID, quantity: 1, properties: props })
    });
  })
  .then(function() {
    window.location.href = '/checkout';
  })
  .catch(function() {
    window.location.href = '/cart';
  });
}

// Init on load
document.addEventListener('DOMContentLoaded', function() {
  // Load BMW models by default
  updateModels();

  // Scroll reveal
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('vis'); });
  }, { threshold: 0.07 });
  document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });
});
